module.exports = __webpack_public_path__ + "6f211234114cd695c71fa8d4f99d4256.svg";